// extracted by mini-css-extract-plugin
module.exports = {"container":"auth_container__237TA","form":"auth_form__1wUhx","field":"auth_field__11uYP","error":"auth_error__3Lpp2","submit":"auth_submit__PCsHE"};